import { useState , useEffect} from 'react'
import Menu from '../common/menu'
import Footer from '../common/footer'
import '../css/main.css'
import axios from 'axios';
import mainImage from '../../../assets/images/home/main-image.png'
import shortAboutImage from '../../../assets/images/home/short-about.png'
import dashboardFeatureImage  from '../../../assets/images/home/dashboard-feature.png'
import cashFeatureImage  from '../../../assets/images/home/cash-feature.png'
import contractsFeatureImage  from '../../../assets/images/home/contracts-feature.png'
import riskFeatureImage  from '../../../assets/images/home/risk-feature.png'
import inventoryFeatureImage from '../../../assets/images/home/inventory-feature.png'

function FeaturesPage() {

   useEffect(() => {
    document.querySelector("._menu").scrollIntoView({ behavior: "auto" });
  }, []);

  return (
         <>
        <div className="_container _white_menu landing-page">
        <Menu from="features" />
        <div className="main-section">
          <div className="title">Recursos da plataforma VLMS</div>
        </div>
      
                
            <div className="features-items">
                     <div className="item dashboard">
                                <div className="text-container">
                                     <label style={{maxWidth:'200px'}}>Tenha uma visão macro do seu negócio</label>
                                     <span className="title">Dashboard</span>
                                      <div className="image-container mobile-view">
                                        <img src={dashboardFeatureImage}/>
                                      </div>
                                     <span className="text">
                                     	Tenha uma visão abrangente e em tempo real dos dados mais relevantes do seu negócio como o estado de contratos, pagamentos por vencer, em atraso, assim como o desempenho das suas receitas.
                                     </span>
                                     <div><button>Testar grátis</button></div>
                                </div>

                                <div className="image-container desktop-view">
                                     <img src={dashboardFeatureImage}/>
                                </div>

                     </div>


                    <div className="item contracts">
                                <div className="image-container desktop-view">
                                     <img src={contractsFeatureImage}/>
                                </div>
                                 <div className="text-container">
                                     <label>Acompanhamento completo</label>
                                     <span className="title">Gestão de Contratos</span>
                                      <div className="image-container mobile-view">
                                     <img src={contractsFeatureImage}/>
                                     </div>
                                     <span className="text">
                                     	Acompanhe o status de cada contrato, desde a solicitação até a liquidação final. Crie e gerencie contratos com facilidade, automatize a cobrança de pagamentos e receba notificações sobre vencimentos próximos. Melhore o atendimento ao cliente e economize tempo valioso.
                                     </span>
                                     <div><button>Testar grátis</button></div>
                                </div>
                     </div>



                     <div className="item cash">
                                 <div className="text-container">
                                     <label>Controlo facilitado</label>
                                     <span className="title">Gestão de Caixa</span>
                                      <div className="image-container mobile-view">
                                     <img src={cashFeatureImage}/>
                                     </div>
                                     <span className="text">
                                    A ferramenta de gestão de caixa da nossa plataforma facilita o controlo de todas as suas transações, incluindo despesas e receitas, permitindo realizar transferências, transações automáticas no desembolso e pagamento de empréstimos.</span>
                                     <div><button>Testar grátis</button></div>
                                </div>

                                <div className="image-container desktop-view">
                                     <img src={cashFeatureImage}/>
                                </div>
                     </div>


                     
                     <div className="item contracts">
                                <div className="image-container desktop-view">
                                     <img src={inventoryFeatureImage}/>
                                </div>
                                 <div className="text-container">
                                     <label>Controlo organizado</label>
                                     <span className="title">Gestão de Bens e Garantias</span>
                                      <div className="image-container mobile-view">
                                     <img src={inventoryFeatureImage}/>
                                     </div>
                                     <span className="text">
                                       Com este módulo, é possível registar e monitorar todos os bens apresentados como garantia nas operações de microcrédito. Associe facilmente cada bem ou garantia a um contrato, acompanhe a sua localização, validade e estado. A nossa plataforma oferece uma visão clara e detalhada dos bens vinculados, ajudando a reduzir o risco de crédito e a garantir maior segurança jurídica para a sua instituição. Tudo de forma simples, organizada e acessível.
                                     </span>
                                     <div><button>Testar grátis</button></div>
                                </div>
                     </div>


                     <div className="item cash">
                                 <div className="text-container">
                                     <label>Tome decisões seguras</label>
                                     <span className="title">Gestão de risco</span>
                                      <div className="image-container mobile-view">
                                     <img src={riskFeatureImage}/>
                                     </div>
                                     <span className="text">
                                        O módulo de gestão de risco da nossa plataforma permite identificar, avaliar e controlar possíveis ameaças nas operações de microcrédito. Analise o perfil do cliente, histórico de pagamentos e outros factores essenciais para uma decisão segura. Além disso, tenha acesso à lista negra (blacklist) de clientes com histórico negativo, evitando novas concessões de crédito a perfis de alto risco. Tome decisões mais informadas e proteja a sustentabilidade da sua instituição. Uma solução prática para quem quer prevenir em vez de remediar.</span>
                                     <div><button>Testar grátis</button></div>
                                </div>

                                <div className="image-container desktop-view">
                                     <img src={riskFeatureImage}/>
                                </div>
                       </div>
             </div>

                         <Footer/>
             </div>

            </>

   )
}

export default FeaturesPage